import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../services/auth.service';
import { AuthApiService } from '../../../services/auth-api.service';

@Component({
  selector: 'app-google-link-account-modal',
  templateUrl: './google-link-account-modal.component.html',
  styleUrls: ['./google-link-account-modal.component.scss']
})
export class GoogleLinkAccountModalComponent {
  constructor(
    private readonly authService: AuthService,
    private readonly authApiService: AuthApiService,
    private readonly dialogRef: MatDialogRef<GoogleLinkAccountModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { email: string; googleIdToken: string }
  ) {}

  confirm() {
    this.authApiService.linkGoogleAccountRequest(this.data.googleIdToken).subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.dialogRef.close();
          this.authService.authorizeUser(response.data);
        }
      }
    });
  }
}
